import { SvgIcon, SvgIconProps } from '@mui/material';

export function ChevronLeftIcon(props: SvgIconProps): React.JSX.Element {
  return (
    <SvgIcon viewBox="0 0 18 18" {...props}>
      <path
        d="M11.25 14.25L6 9L11.25 3.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </SvgIcon>
  );
}
